import type { Step } from 'react-joyride';

export const policyListTourSteps: Step[] = [
    {
        target: 'body',
        content:
            'ຍິນດີຕ້ອນຮັບສູ່ໜ້າລາຍການນະໂຍບາຍ. ທ່ານສາມາດຄົ້ນຫາ, ກັ່ນຕອງ, ແລະ ຈັດການນະໂຍບາຍໄດ້ຈາກໜ້ານີ້.',
        placement: 'center',
        disableBeacon: true,
    },
    {
        target: '[data-tourid="policy-list-toolbar"]',
        content:
            'ສ່ວນຫົວໜ້າ: ສະແດງຫົວຂໍ້ໜ້າ, ປຸ່ມເລີ່ມທົດສອບ, ແລະ ປຸ່ມເພີ່ມນະໂຍບາຍ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-list-filter"]',
        content:
            'ກັ່ນຕອງຕາມປະເພດ, ສະຖານະ ແລະ ຄຳຄົ້ນຫາ ເພື່ອເຫັນຂໍ້ມູນຕາມທີ່ຕ້ອງການ.',
        placement: 'bottom',
    },
    {
        target: '[data-tourid="policy-list-table"]',
        content:
            'ຕາຕະລາງລາຍການນະໂຍບາຍ: ເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ສຳເນົາ, ຫຼື ຈັດການສະຖານະໄດ້ຈາກທີ່ນີ້.',
        placement: 'top',
    },
];
